module.exports = __webpack_public_path__ + "img/card-bg-3-old.64367a8.png";